<template>
    <v-container :class="{'py-0': !isDesktop}">
        <v-row>
            <v-col cols="12 py-0" :class="{'px-0': !isDesktop}">
                <div class="d-flex flex-column" :class="{'pt-0': isDesktop}">
                    <slot></slot>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {}
</script>